module.exports = __webpack_public_path__ + "img/download.c2e14ffd.svg";